module.exports = __webpack_public_path__ + "img/due_soon.4805d7c4.png";